import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { protectedRoutes } from './protected';
import { publicRoutes, commonRoutes, iframeRoutes } from './public';
import _ from 'lodash';
import useIframe from '@/hooks/useIframe';

export const AppRoutes = () => {
  const { user } = useAuth();
  const location = useLocation();
  const isDeepDiveEnabled = useFeatureFlagEnabled('deep-dive');
  const isDiscoverEnabled = useFeatureFlagEnabled('discover');
  const isPetaReportsEnabled = useFeatureFlagEnabled('peta-reports');
  const isTemplatesEnabled = useFeatureFlagEnabled('templates');
  const isSettingsIntegrationsEnabled = useFeatureFlagEnabled(
    'settings-integrations'
  );
  const isDashboardsEnabled = useFeatureFlagEnabled('dashboards');
  const { isAppInIframe, iframeAccessTokenGenerating } = useIframe();

  const posthogFlags = {
    'deep-dive': true,
    // 'deep-dive': isDeepDiveEnabled,
    discover: isDiscoverEnabled,
    'peta-reports': isPetaReportsEnabled,
    templates: isTemplatesEnabled,
    'settings-integrations': isSettingsIntegrationsEnabled,
    dashboards: isDashboardsEnabled,
  };

  const getAuthorizedRoutes = () => {
    const authorizedRoutes = _.cloneDeep(protectedRoutes);
    return authorizedRoutes.filter((route) => {
      if (user) {
        if (route.children) {
          route.children = route.children.filter((childRoute) => {
            if (isAppInIframe) {
              return childRoute.enableRouterInIframe;
            } else if (!childRoute.role) {
              // enable route for all user roles
              if (typeof posthogFlags[childRoute.posthogFlag] === 'boolean') {
                // if posthog present, decide based on flag
                return posthogFlags[childRoute.posthogFlag];
              } else {
                return true;
              }
            } else {
              // enable route based on user roles
              if (typeof posthogFlags[childRoute.posthogFlag] === 'boolean') {
                // if posthog present, decide based on flag and user role
                return (
                  posthogFlags[childRoute.posthogFlag] &&
                  user.role?.toLowerCase() === childRoute.role
                );
              } else {
                // if not posthog present, disable based on user role
                return user.role?.toLowerCase() === childRoute.role;
              }
            }
          });
        }
        return route;
      }
    });
  };

  let routes = [];

  if (!isAppInIframe && !user) {
    let allPublicRoutes = publicRoutes;
    if (!location.pathname.includes('/auth/') && location.pathname !== '/') {
      if (Array.isArray(allPublicRoutes) && allPublicRoutes.length > 0) {
        // for all paths other than login and /, if the route is accessed while user is unauthenticated, then redirect url is added in the login url
        allPublicRoutes.forEach((route) => {
          if (route?.path && route?.element && route.path === '*') {
            route.element = (
              <Navigate
                to={`/auth/login?redirect=${encodeURIComponent(location.pathname)}`}
              />
            );
          }
        });
      }
    }
    routes = allPublicRoutes;
  } else if (!iframeAccessTokenGenerating) {
    routes = getAuthorizedRoutes();
  } else if (iframeAccessTokenGenerating) {
    routes = iframeRoutes;
  }

  if (!isAppInIframe) {
    routes = [...routes, ...commonRoutes];
  }

  const element = useRoutes(routes);

  return <>{element}</>;
};
